import { render, staticRenderFns } from "./ResultsMacroTagBox.vue?vue&type=template&id=f82c4076&scoped=true&"
import script from "./ResultsMacroTagBox.vue?vue&type=script&lang=js&"
export * from "./ResultsMacroTagBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82c4076",
  null
  
)

export default component.exports